export default {
  home: '/',
  dashboard: '/dashboard',
  terms: '/terms',
  legalPolicy: '/legal-policy',
  privacyPolicy: '/privacy-policy',
  b2bPolicy: '/customer-privacy-policy',
  statsDashboard: '/stats-dashboard'
}
